import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const enableFeatureFlag = mutator({
  schema: z.object({ id: z.string(), name: z.string() }),
  resolve: {},
  permissions: [
    {
      permission: "tenant:feature_flags_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, ctx, args: { id, name } }) => {
    const [existing] = await tx.run(
      zql.featureFlags.where("name", name).where("tenantId", ctx.tenantId)
    );
    const now = Date.now();

    if (existing) {
      if (existing.enabledAt) return;
      await tx.mutate.featureFlags.update({
        id: existing.id,
        enabledAt: now,
        updatedAt: now,
      });
    } else {
      await tx.mutate.featureFlags.insert({
        id,
        name,
        createdAt: now,
        updatedAt: now,
        enabledAt: now,
        createdByUserId: ctx.userId,
        tenantId: ctx.tenantId,
      });
    }
  },
});
